import React from 'react';
import {
  Box, Typography, Stack, Chip, IconButton, Tooltip,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import OpportunityPipeline from '../ui/OpportunityPipeline';
import { formatValue } from '../../utils/format';

const CHIP_SX = {
  height: 20,
  fontSize: '0.7rem',
  fontWeight: 600,
  bgcolor: 'rgb(var(--color-primary-500) / 0.08)',
  color: 'primary.dark',
};

// หัวหน้ารายละเอียดแบบแถบเดียวกะทัดรัด — เดิมเป็น hero gradient สูง + การ์ด pipeline ลอยทับ (กินพื้นที่
// ~380px ใน popup) ย่อเหลือแถบเดียว: ซ้าย = ย้อนกลับ/เลขโครงการ/ป้าย/ชื่อโครงการ, ขวา = pipeline ขนาดเล็ก
// + มูลค่างาน (เฉพาะได้งาน) จอแคบ pipeline ตกลงบรรทัดใหม่ (flexWrap) คงโทนม่วงไว้ที่แถบขอบซ้าย
export function OpportunityDetailHeader({ opportunity, onBack }) {
  const showValue = opportunity.status === 'WON' && opportunity.value != null;

  return (
    <Box
      sx={{
        mb: 3,
        position: 'relative',
        overflow: 'hidden',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 3,
        pl: { xs: 1.5, md: 2 },
        pr: { xs: 1.5, md: 2.5 },
        py: 1.25,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        columnGap: 3,
        rowGap: 1.5,
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: 4,
          background: 'linear-gradient(180deg, rgb(var(--color-primary-700)) 0%, rgb(var(--color-primary-450)) 100%)',
        },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flex: '1 1 320px', minWidth: 0 }}>
        <Tooltip title="ย้อนกลับ">
          <IconButton
            onClick={onBack}
            size="small"
            sx={{ border: '1px solid', borderColor: 'divider', color: 'text.secondary' }}
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Box sx={{ minWidth: 0 }}>
          <Stack direction="row" alignItems="center" spacing={0.75} sx={{ minWidth: 0 }}>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 700, letterSpacing: 0.6, color: 'primary.main', flexShrink: 0,
              }}
            >
              {opportunity.opportunity_number}
            </Typography>
            {opportunity.is_tender && <Chip size="small" label="งานประมูล" sx={CHIP_SX} />}
            <Chip
              size="small"
              label={opportunity.contact_name_snapshot || 'ไม่ระบุลูกค้า'}
              sx={{ ...CHIP_SX, maxWidth: 260 }}
            />
          </Stack>
          <Tooltip title={opportunity.project_name || ''} placement="bottom-start">
            <Typography
              variant="h6"
              noWrap
              sx={{ fontWeight: 800, lineHeight: 1.3, fontSize: { xs: '1rem', md: '1.15rem' } }}
            >
              {opportunity.project_name}
            </Typography>
          </Tooltip>
        </Box>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={3} sx={{ flex: '0 1 460px', minWidth: 260 }}>
        <Box sx={{ flex: 1 }}>
          <OpportunityPipeline status={opportunity.status} />
        </Box>
        {showValue && (
          <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.2 }}>
              มูลค่างาน
            </Typography>
            <Typography sx={{ fontWeight: 800, fontSize: '1rem', color: 'success.main' }}>
              {formatValue(opportunity.value)}
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
}

export default OpportunityDetailHeader;
